import { useAppStore } from "@/stores/app";
import { ruCustomMessages, ruComponentMessages} from '@/messages/ru-RU.js';
import { enComponentMessages, enCustomMessages} from '@/messages/en-US.js';

export const getMessageByLang = (text, textDefault) => {
    const appStore = useAppStore();
    const currentLang = appStore.getCurrentLang;
    let message = null;

    switch(currentLang) {
        case 'ru':
            if(ruCustomMessages[text]) {
                message = ruCustomMessages[text];
            } else if(ruComponentMessages[text]) {
                message = ruComponentMessages[text];
            }
            break;

        case 'en':
            if(enComponentMessages && enComponentMessages[text]) {
                message = enComponentMessages[text];
            } else if(enCustomMessages && enCustomMessages[text]) {
                message = enCustomMessages[text];
            }
            break;
    }

    if(!message) {
        return textDefault;
    }

    return message;
} 